import { TextField } from '@material-ui/core';
import { CustomInput } from '../../common/SimpleInput';
import { Accordion } from 'devextreme-react';
import { AccordionGroup } from './Accordion';
import dayjs from 'dayjs';
import { useState } from 'react';
import { formatToCNPJ } from '../../../commonFunctions/FormatterFunctions';
import { locale } from 'devextreme/localization';

function AditionalInfoForm(props) {
  locale('pt-BR');
  
  const { handleChange, editMode, contractFormData } = props;

  function getServiceDataValue(id) {
    const result = contractFormData.services != null ? contractFormData?.services.indexOf(id) !== -1 : false;
    return result;
  }

  const servicoCombo = [
    //{ label: 'Manutenção Assistida', field: contractFormData.field.customerValid ? 'Sim' : 'Não' },
    { label: 'Manutenção Assistida', value: getServiceDataValue(1), id: 1 },
    { label: 'Atendimento 0800 compartilhado', value: getServiceDataValue(2), id: 2 },
    { label: 'Assistência 24h', value: getServiceDataValue(3), id: 3 },
    { label: 'Gestão de Notificações e Multas + SNE', value: getServiceDataValue(4), id: 4 },
    { label: 'Telemetria + Monitoramento', value: getServiceDataValue(5), id: 5 },
    { label: 'Gestão Documental', value: getServiceDataValue(6), id: 6 },
    { label: 'Atendimento 0800 dedicado (+ 5.000,00 / mês)', value: getServiceDataValue(7), id: 7 },
    { label: 'Concierge', value: getServiceDataValue(8), id: 8 },
  ];
  const servicoAvulso = [
    { label: 'Consulta Sistêmica de Notificações e Multas', value: getServiceDataValue(9), id: 9 },
    { label: 'Análise de Crédito - Analítico PJ', value: getServiceDataValue(10), id: 10 },
    { label: 'Análise de Crédito - Sistema PF', value: getServiceDataValue(11), id: 11 },
    { label: 'Contabilidade Mensal', value: getServiceDataValue(12), id: 12 },
    { label: 'Consultoria Contábil e Tributária', value: getServiceDataValue(13), id: 13 },
    { label: 'Assinatura Eletrônica', value: getServiceDataValue(14), id: 14 },
    { label: 'Financiamento', value: getServiceDataValue(15), id: 15 },
    { label: 'Compras de Veículos', value: getServiceDataValue(16), id: 16 },
    { label: 'Seguro', value: getServiceDataValue(17), id: 17 },
  ];
  const sistemas = [
    { label: 'Rental', value: getServiceDataValue(18), id: 18 },
    { label: 'Pricing', value: getServiceDataValue(19), id: 19 },
    { label: 'Portal de vendas', value: getServiceDataValue(20), id: 20 },
  ];

  const serviceAccordionContent = () => {
    return (
      <>
        {contractFormData?.services && (
          <Accordion
            dataSource={[
              {
                title: 'Serviço Combo',
                body: servicoCombo.map((item) => (
                  <CustomInput key={item.label} type="checkbox" onChange={(e) => handleChange(e.target.checked, `service-${item.id}`)} label={item.label} value={item.value} readOnly={!editMode} />
                )),
              },
              {
                title: 'Serviço Avulso',
                body: servicoAvulso.map((item) => (
                  <CustomInput key={item.label} type="checkbox" onChange={(e) => handleChange(e.target.checked, `service-${item.id}`)} label={item.label} value={item.value} readOnly={!editMode} />
                )),
              },
              {
                title: 'Sistemas',
                body: sistemas.map((item) => (
                  <CustomInput key={item.label} type="checkbox" onChange={(e) => handleChange(e.target.checked, `service-${item.id}`)} label={item.label} value={item.value} readOnly={!editMode} />
                )),
              },
            ]}
            collapsible
            multiple
            // selectedItems={selectedServices}
            // onSelectionChanged={(e) => selectionServiceChanged(e)}
            itemTitleRender={(data) => {
              return (
                <>
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#3B5158', marginRight: 15 }}>{data.title}</span>
                </>
              );
            }}
            itemRender={(data) => {
              return <div className="grid-contract">{data.body}</div>;
            }}
          />
        )}
      </>
    );
  };

  return (
    <>
      <div className="grid-contract" style={editMode ? { gridTemplateColumns: `repeat(1, 1fr)`, gridAutoRows: '75px' } : null}>
        {/* <CustomInput type="text" onChange={(e) => handleChange(e, "userName")} label="Nombre" value={contractFormData.userName} readOnly={!editMode} size={"xxs"} maxValue={150}/>
                <CustomInput type="text" onChange={(e) => handleChange(e, "userSurnames")} label="Apellidos" value={contractFormData.userSurnames} readOnly={!editMode} size={"xxs"} maxValue={150}/>
                <CustomInput type="text" onChange={(e) => handleChange(e, "mobilePhone")} label="Telefono Movil" value={contractFormData.mobilePhone} readOnly={!editMode} size={"xxs"} />
                <CustomInput type="text" onChange={(e) => handleChange(e, "phone")} label="Telefono Fijo" value={contractFormData.phone} readOnly={!editMode} size={"xxs"} />
                <CustomInput type="text" onChange={(e) => handleChange(e, "kilometrage")} label="Kilometraje" value={contractFormData.kilometrage} readOnly={!editMode} size={"xxs"} />
                <CustomInput type="text" onChange={(e) => handleChange(e, "licenseNumber")} label="Numero Carnet" value={contractFormData.licenseNumber} readOnly={!editMode} size={"xxs"} />
                <CustomInput type="text" onChange={(e) => handleChange(e, "email")} label="Email" value={contractFormData.email} readOnly={!editMode} size={"xxs"} />
                <div className ="checkPau"><CustomInput type="checkbox" onChange={(e) => handleChange(e, "driversClub")} label="Tarjeta Driver" value={contractFormData.driversClub} readOnly={!editMode} row={editMode} /></div>
                <div className ="datePau"><CustomInput clearField={()=>handleChange(null, "driversClubDate")} type="date" className ="datePau" onChange={(e) => handleChange(e, "driversClubDate")} label="Inicio tarjeta Driver" value={contractFormData.driversClubDate} readOnly={!editMode} size={"xxs"} datetype={"date"} row/></div> */}

        <CustomInput type="text" onChange={(e) => handleChange(e.value, 'cnpjMatriz')} label="CNPJ Matriz" value={formatToCNPJ(contractFormData.cnpjMatriz)} mask="00.000.000/0000-00"
              placeholder="00.000.000/0000-00"
              showMaskMode="onFocus"
              maskRules={{ 0: /[0-9]/ }}
              readOnly={!editMode} size={'xxs'} />



        <CustomInput type="currency" onChange={(e) => handleChange(e.value, 'creditTotal')} label="Crédito total" value={contractFormData.creditTotal} readOnly={!editMode} size={'xxs'} />
        <CustomInput type="currency" onChange={(e) => handleChange(e.value, 'creditUsed')} label="Crédito utilizado" value={contractFormData.creditUsed} readOnly={!editMode} size={'xxs'} />
        <CustomInput
          type="currency"
          onChange={(e) => handleChange(e.value, 'creditUsed')}
          label="Crédito disponível"
          value={contractFormData.creditTotal - contractFormData.creditUsed}
          readOnly={true}
          size={'xxs'}
        />

        <CustomInput
          type="currency"
          onChange={(e) => handleChange(e.value, 'currentAccountLimit')}
          label="Limite Giro Conta Corrente"
          value={contractFormData.currentAccountLimit}
          readOnly={!editMode}
          size={'xxs'}
        />
        <CustomInput
          type="currency"
          onChange={(e) => handleChange(e.value, 'specialCheckLimit')}
          label="Limite Cheque Especial"
          value={contractFormData.specialCheckLimit}
          readOnly={!editMode}
          size={'xxs'}
        />
        <CustomInput
          type="currency"
          onChange={(e) => handleChange(e.value, 'corporateCardLimit')}
          label="Limite Cartão Corporativo"
          value={contractFormData.corporateCardLimit}
          readOnly={!editMode}
          size={'xxs'}
        />
        <CustomInput
          type="currency"
          onChange={(e) => handleChange(e.value, 'franchiseLimit')}
          label="Limite Giro Franquias"
          value={contractFormData.franchiseLimit}
          readOnly={!editMode}
          size={'xxs'}
        />

        {/* <CustomInput type="text" onChange={(e) => handleChange(e, "creditLimitDate")} label="Data limite de crédito" value={contractFormData.creditLimitDate} readOnly={!editMode} size={"xxs"} /> */}

        <CustomInput
          clearField={() => handleChange(null, 'creditLimitDate')}
          type="date"
          onChange={(e) => handleChange(e, 'creditLimitDate')}
          label="Data limite de crédito"
          value={contractFormData.creditLimitDate}
          readOnly={!editMode}
          size={'xxs'}
          datetype={'date'}
        />

        <div className="input-wrapper-col" style={{ backgroundColor: '#DBE6E0', fontWeight: '900' }}>
          <span>Serviço Combo</span>
        </div>
        {servicoCombo.map((item) => (
          <CustomInput key={item.label} type="checkbox" onChange={(e) => handleChange(e.target.checked, `service-${item.id}`)} label={item.label} value={item.value} readOnly={!editMode} />
        ))}
        <div className="input-wrapper-col" style={{ backgroundColor: '#DBE6E0', fontWeight: '900' }}>
          <span>Serviço Avulso</span>
        </div>
        {servicoAvulso.map((item) => (
          <CustomInput key={item.label} type="checkbox" onChange={(e) => handleChange(e.target.checked, `service-${item.id}`)} label={item.label} value={item.value} readOnly={!editMode} />
        ))}
        <div className="input-wrapper-col" style={{ backgroundColor: '#DBE6E0', fontWeight: '900' }}>
          <span>Sistemas</span>
        </div>
        {sistemas.map((item) => (
          <CustomInput key={item.label} type="checkbox" onChange={(e) => handleChange(e.target.checked, `service-${item.id}`)} label={item.label} value={item.value} readOnly={!editMode} />
        ))}
      </div>

      {/* {serviceAccordionContent()} */}
    </>
  );
}

export { AditionalInfoForm };
